export function isPrivacyTextAvailable (translations) {
    return !!(translations && translations['sync.components.privacy_text']);
}

export function isScheduleHeadingTextAvailable (translations) {
    return !!(translations && translations['sync.containers.schedule.heading_text']);
}
